import type { AnimalHealthState } from '@tendedloop/shared';

/**
 * Living Nature health filters. No sepia - the full-color habitat paintings
 * are shown at varying vibrancy levels. The animal stays vivid; only the
 * intensity changes to signal health state.
 */
export const HEALTH_FILTERS: Record<AnimalHealthState, string> = {
  thriving: 'opacity-100 saturate-[1.3]',
  fading: 'opacity-70 saturate-[0.6] brightness-[0.85]',
  'at-risk': 'opacity-45 saturate-[0.3] brightness-[0.75] grayscale-[0.3]',
};

export const HEALTH_COLORS: Record<AnimalHealthState, string> = {
  thriving: 'bg-emerald-500',
  fading: 'bg-amber-400',
  'at-risk': 'bg-red-400',
};

export const HEALTH_LABELS: Record<AnimalHealthState, string> = {
  thriving: 'Thriving',
  fading: 'Fading',
  'at-risk': 'At risk',
};

/**
 * Shape styles for health indicators (WCAG 1.4.1 - not color-only).
 * Thriving = circle, Fading = wide pill (horizontal bar), At Risk = diamond.
 * Shapes must be visually distinct at 10px (2.5 Tailwind units).
 */
export const HEALTH_SHAPES: Record<AnimalHealthState, string> = {
  thriving: 'rounded-full',
  fading: 'rounded-full w-3.5 h-1.5',
  'at-risk': 'rotate-45',
};
